class OjaIngredients extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  toggle(tile) {
    const open = tile.getAttribute('aria-expanded') === 'true';
    this.querySelectorAll('[data-ingredient-tile]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
    tile.setAttribute('aria-expanded', (!open).toString());
  }

  onClick = (event) => {
    const tile = event.target.closest('[data-ingredient-tile]');
    if (tile) this.toggle(tile);
  };

  onKeydown = (event) => {
    const tile = event.target.closest('[data-ingredient-tile]');
    if (!tile || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    this.toggle(tile);
  };
}

if (!customElements.get('oja-ingredients')) {
  customElements.define('oja-ingredients', OjaIngredients);
}
